import { Application } from '../../slices/account-api.slice';

export const mockCustomerNames: string[] = [
    'Workday',
    'FedEx',
    'Capital One',
    'Kimberly-Clark',
    'Talk Talk',
    'Chevron',
    'Suncor',
    'Trinity Health',
    'Panera'
];

export const mockAppNames: string[] = ['Application Name', 'Ground Services', 'Financials Group', 'Student Services'];

export const generateMockApplications = (): Application[] => {
    const applications: Application[] = [];
    mockCustomerNames.forEach((customerName: string, companyIndex: number) => {
        for (let i = 0; i < customerName.length; i++) {
            applications.push({
                ...boaApplication,
                appId: '58a7f6b-f16d-4d32-b825-a085fa8ff5' + companyIndex + i,
                name: mockAppNames[i % mockAppNames.length] + (i % 5 === 0 ? ' Longer App Name' : ''),
                vcrRestricted: i % 4 === 0,
                customer: customerName,
                tenantName:
                    (companyIndex + i) % 3 === 0
                        ? 'Mytenantname_00' + i
                        : 'Myverylongtenantnamethatwontfitinthespacegiven_00' + i
            });
        }
    });

    return applications;
};

export const boaApplication: Application = {
    appId: '58a7f6b-f16d-4d32-b825-a085fa8ff5',
    clientId: '4521b3c7-9ac4-45ba-81e1-07f15c748a60',
    customer: 'Bank of America',
    name: 'Peakon',
    url: 'http://peakon.com',
    isEnvApp: true,
    environment: 'WD5-IMPL',
    environmentType: 'IMPL',
    vcrRestricted: false,
    // tenanted only props?
    tosUri: 'http://example.com/terms',
    privacyUri: 'http://example.com/privacy',
    tenantName: 'Acme',
    sandBoxed: false,
    expired: false,
    userExpired: false,
    userLocked: false
};

export const fedexApplication: Application = {
    appId: '58a7f6b-f16d-4d32-b825-a085fa8ff4',
    clientId: '4521b3c7-9ac4-45ba-81e1-07f15c748a61',
    customer: 'FedEx',
    name: 'Tuocs',
    url: 'http://tuocs.com',
    isEnvApp: false,
    environment: 'WD5-IMPL',
    vcrRestricted: false,
    sandBoxed: false,
    expired: false,
    userExpired: false,
    userLocked: false
};

export const upsTenantApplication: Application = {
    appId: '58a7f6b-f16d-4d32-b825-a085fa8ff5',
    clientId: '4521b3c7-9ac4-45ba-81e1-07f15c748a62',
    customer: 'UPS',
    name: 'Workday',
    url: 'http://ups.com',
    isEnvApp: true,
    environment: 'WD5-IMPL',
    environmentType: 'IMPL',
    vcrRestricted: true,
    tosUri: 'http://example.com/terms',
    privacyUri: 'http://example.com/privacy',
    tenantName: 'Acme',
    sandBoxed: false,
    expired: false,
    userExpired: false,
    userLocked: false
};

export const dhlTenantApplication: Application = {
    appId: '58a7f6b-f16d-4d32-b825-a085fa8ff5',
    clientId: '4521b3c7-9ac4-45ba-81e1-07f15c748a62',
    customer: 'DHL',
    name: 'Workday',
    url: 'http://dhl.com',
    isEnvApp: true,
    environment: 'WD5-IMPL',
    environmentType: 'SANDBOX',
    vcrRestricted: true,
    tosUri: 'http://example.com/terms',
    privacyUri: 'http://example.com/privacy',
    tenantName: 'Acme',
    sandBoxed: false,
    expired: false,
    userExpired: false,
    userLocked: false
};

export const hlTenantApplicationExpired: Application = {
    appId: '58a7f6b-f16d-4d32-b825-a085fa8ff5',
    clientId: '4521b3c7-9ac4-45ba-81e1-07f15c748a62',
    customer: 'DHL',
    name: 'Workday',
    url: 'http://dhl.com',
    isEnvApp: true,
    environment: 'WD5-IMPL',
    environmentType: 'SANDBOX',
    vcrRestricted: true,
    tosUri: 'http://example.com/terms',
    privacyUri: 'http://example.com/privacy',
    tenantName: 'Acme',
    sandBoxed: true,
    expired: true,
    userExpired: false,
    userLocked: false
};

export const suvSuperApplication: Application = {
    appId: '58a7f6b-f16d-4d32-b825-a085fa8ff5',
    clientId: '4521b3c7-9ac4-45ba-81e1-07f15c748a62',
    customer: 'DHL',
    name: 'Workday',
    url: 'http://dhl.com',
    isEnvApp: true,
    environment: 'suv',
    environmentType: 'SUDEV_n-l9hfk5mfcncl49aghc4ge',
    vcrRestricted: true,
    tosUri: 'http://example.com/terms',
    privacyUri: 'http://example.com/privacy',
    tenantName: 'Acme',
    sandBoxed: false,
    expired: false,
    userExpired: false,
    userLocked: false
};

export const wgcTenantApplication: Application = {
    appId: '58a7f6b-f16d-4d32-b825-a085fa8ff5',
    clientId: '4521b3c7-9ac4-45ba-81e1-07f15c748a62',
    customer: 'DHL',
    name: 'Workday',
    url: 'http://dhl.com',
    isEnvApp: true,
    environment: 'WD104-IMPL',
    environmentType: 'IMPL',
    vcrRestricted: true,
    tosUri: 'http://example.com/terms',
    privacyUri: 'http://example.com/privacy',
    tenantName: 'Acme',
    sandBoxed: false,
    expired: false,
    userExpired: false,
    userLocked: false,
    isFedRAMP: true
};
